//https://api.xdevel.com/streamsolution/web/player/songs/history/8?clientId=8d9d19f879ad54d1dfd9936eb0f7bbadbb70152e

/*
{
    success: true,
    message: "ok",
    result: [
        {
            metadata: "SURFACES - Sunday Best",
            metadataArtist: "SURFACES",
            metadataTitle: "Sunday Best",
            artist: "Surfaces",
            title: "Sunday Best",
            isNew: false,
            isHit: true,
            label: "Polydor",
            radioDate: "2020-03-13",
            earoneChart: {
            weeks: 6,
            curPos: 16,
            prevPos: 17,
            chartDate: "2020-04-16"
            },
            earoneSongId: 48255,
            artistUrl: "https://www.facebook.com/surfacesmusic",
            album: "Where the Light Is",
            year: "2019",
            storeUrl: "https://music.apple.com/it/album/sunday-best/1465951330?i=1465952235&uo=4",
            previewUrl: "https://audio-ssl.itunes.apple.com/itunes-assets/AudioPreview113/v4/c2/74/7b/c2747b2d-371b-7b1c-5506-587ae0ac0b91/mzaf_13792785665741912376.plus.aac.p.m4a",
            artistImageList: [
            "https://i.scdn.co/image/0d125e224948b5e4716239384839230205832084"
            ],
            artworkSmall: "https://is4-ssl.mzstatic.com/image/thumb/Music123/v4/db/29/0a/db290aa6-409e-7900-8fb1-b8812e1eac18/source/300x300bb.jpg",
            artworkLarge: "https://is4-ssl.mzstatic.com/image/thumb/Music123/v4/db/29/0a/db290aa6-409e-7900-8fb1-b8812e1eac18/source/1000x1000bb.jpg",
            detectedOn: "2020-04-20T13:04:56.589Z"
        }
    ]
}
 */

export default function (data, limit = 5) {
    let result = [];
    let count = 0;

    if (data.success) {
        let item;
        for (let i = 0; i < data.result.length; i++) {
            item = data.result[i];
            if (count >= limit) break;
            if (!item.artworkSmall || (item.artworkSmall + '').includes('null.jpg')) continue;

            result.push({
                artist: item.artist,
                title: item.title,
                artwork: item.artworkSmall,
                datePlay: new Date(item.detectedOn).toLocaleTimeString()
            });
            count++;
        }
    }

    return result;
}